import React, { ReactElement, useEffect, useState } from 'react';
import { Button, LoaderButton } from 'idsk-react-components';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router';
import { OrganizacnaSkupinaEnum } from 'ciselniky-frontend-ts-axios';
import { BackButton, ConfirmModal, OrganizaciaInput } from 'slovlex-idsk-react-components';
import './rokovaniePov.scss';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import { useClient } from '../../../context/ClientStatusContext';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { startRokovaniePov } from '../../../client/pracovnyKrok/rokovaniePovClient';
import routes from '../../../routing/routes';
import useOrganizacie from '../../../hooks/useOrganizacie';
import Organizacia from '../../../model/ciselniky/Organizacia';

const RokovaniePov = (): ReactElement => {
  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();
  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
  } = useFieldErrorMessages();
  const {
    type,
    year,
    index,
    pracovnyKrokId,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, pracovnyKrokId: string }>();
  const {
    organizacie: organizaciaList,
    organizacieStatus: organizaciaListStatus,
  } = useOrganizacie(OrganizacnaSkupinaEnum.Pov, true);

  const [poradneOrganyVlady, setPoradneOrganyVlady] = useState<Array<Organizacia>>([]);

  const {
    wrapClient: rokovaniePovClient,
    status: rokovaniePovStatus,
  } = useClient(startRokovaniePov);

  const onStartRokovaniePov = async (): Promise<void> => {
    const poradnyOrganVladyList = poradneOrganyVlady.filter(pov => pov !== null)
      .map(poradnyOrgan => poradnyOrgan.uuid);
    await rokovaniePovClient(type, year, index, pracovnyKrokId, poradnyOrganVladyList);
    navigate(routes.procesy.detail.withParams(type, year, index));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  useEffect(() => {
    if (organizaciaList?.length > 0) {
      const defaultOrg = organizaciaList.find(organizacia => organizacia.nazov.includes('Legislatívna rada'));
      if (defaultOrg) {
        setPoradneOrganyVlady([defaultOrg]);
      } else {
        setPoradneOrganyVlady([organizaciaList[0]]);
      }
    }
  }, [organizaciaList]);

  const mapOrganizacie = (): Array<Organizacia> => organizaciaList?.map(
    organizacia => ({
      uuid: organizacia.uuid,
      nazov: organizacia.nazov.concat(` (${organizacia.email})`),
    }),
  );

  return (
    <div className="rokovanie-pov">
      <OrganizaciaInput
        data={mapOrganizacie()}
        itemList={poradneOrganyVlady}
        setItemList={(pov) => {
          setPoradneOrganyVlady(pov);
          clearFieldErrorMessage('poradneOrganyVlady');
        }}
        addButtonLabel="+ &nbsp; Pridať ďalší poradný orgán"
        label="Poradné orgány vlády"
        error={getFieldErrorMessage('poradneOrganyVlady')}
        loading={organizaciaListStatus.loading}
        width="two-thirds"
      />
      <div className="action-buttons">
        <ConfirmModal
          question={'Naozaj si prajete spustiť štádium "Rokovanie poradných orgánov vlády" a odoslať '
            + 'emailové notifikácie so sprievodnými dokumentami pre nakonfigurované poradné orgány?'}
          description={'Po spustení štádia "Rokovanie poradných orgánov vlády" budú odoslané emailové '
            + 'notifikácie so zoznamom aktuálne pridaných sprievodných dokumentov k materiálu '
            + 'nakonfigurovaným poradným orgánom a nebude možné spustiť štádium "Rokovanie vlády" '
            + 'pokiaľ nebude štádium "Rokovanie poradných orgánov vlády" ukončené.'}
          cancelButtonText="Nie"
          confirmButton={
            (
              <Button
                buttonStyle="action"
                size="large"
              >
                Áno
              </Button>
            )
          }
          openButton={(
            <LoaderButton
              id="odoslatButton"
              loading={rokovaniePovStatus.loading}
              size="large"
              disableOutsideClickWhileLoading
            >
              Spustiť rokovanie POV a odoslať emailové notifikácie
            </LoaderButton>
          )}
          doAfterConfirm={onStartRokovaniePov}
        />
        <BackButton disabled={rokovaniePovStatus?.loading} />
      </div>
    </div>
  );
};
export default RokovaniePov;
